import { render, staticRenderFns } from "./Shift_control.vue?vue&type=template&id=37fc460f&scoped=true"
import script from "./Shift_control.vue?vue&type=script&lang=js"
export * from "./Shift_control.vue?vue&type=script&lang=js"
import style0 from "./Shift_control.vue?vue&type=style&index=0&id=37fc460f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc460f",
  null
  
)

export default component.exports